/**
 * Created by vladislav on 30.12.2019
 */

cleverapps.SkinManager = function () {
    this.active = [];

    this.defaultSlots = cleverapps.SkinManager.SKINS.default.slots;
};

cleverapps.SkinManager.prototype.getLink = function (link) {
    if (!this.active.length) {
        return link;
    }

    for (let i = 0; i < this.active.length; i++) {
        const active = this.active[i].slots;
        const skin = active && active.skinName && active.skinName();
        const url = skin && this.overrides[skin] && this.overrides[skin][link];
        if (url) {
            return url;
        }
    }

    return link;
};

cleverapps.SkinManager.prototype.getSlot = function (slotName, options) {
    for (let i = 0; i < this.active.length; i++) {
        if (this.active[i] && this.active[i].slots[slotName]) {
            const slot = this.active[i].slots[slotName];
            const skinned = typeof slot === "function" ? slot(options) : slot;

            if (skinned !== undefined) {
                return skinned;
            }
        }
    }

    return this.defaultSlots[slotName] && this.defaultSlots[slotName](options);
};

cleverapps.SkinManager.prototype.update = function () {
    this.active = [];

    const location = cleverapps.meta.getSelectedLocation();

    if (cleverapps.SkinManager.SKINS[`${location.locationId}_expedition`]) {
        this.active.push(cleverapps.SkinManager.SKINS[`${location.locationId}_expedition`]);
    }

    if (cleverapps.config.type === "merge") {
        if (cleverapps.SkinManager.SKINS.xmas && cleverapps.eventManager && cleverapps.eventManager.isActive("xmas")) {
            this.active.push(cleverapps.SkinManager.SKINS.xmas);
        }

        return;
    }

    if (!cleverapps.eventManager) {
        return;
    }

    cleverapps.eventManager.listCurrentFeatures().forEach(function (feature) {
        if (cleverapps.SkinManager.SKINS[feature]) {
            this.active.push(cleverapps.SkinManager.SKINS[feature]);
        }
    }, this);
};

cleverapps.SkinManager.prototype.getBundles = function () {
    const bundles = [];
    this.active.forEach((skin) => {
        if (skin && skin.bundle) {
            bundles.push(skin.bundle);
        }
    });

    return bundles.length > 0 ? bundles : undefined;
};

cleverapps.SkinManager.SKINS = {
    default: {
        slots: {
            skinName: function () {
                const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
                return locationConfig.isMain ? undefined : bundles[locationConfig.locationBundleId].meta.units;
            },
            windowDecors: function (options) {
                return options.decors;
            },
            windowBg: function (options) {
                return options.image;
            },
            spine: function (options) {
                return options.json;
            },
            menuBarItem: function () {},
            controlButton: function () {},
            gameAudio: function () {},
            missionIcon: function (options) {
                const icon = Missions[options.type].collectIcon;
                return typeof icon === "function" ? icon() : icon;
            },
            removeMissions: function () {
            },
            toolbarDecors: function () {
                return [];
            },
            localization: function (code) {
                return cleverapps.SkinManager.SKINS.default.localization[code];
            },
            windowTitle: function (options) {
                return options.image;
            },
            missionMarkIcon: function (options) {
                return Missions[options.type].collectIcon;
            },
            missionWindowTitleFont: function () {
                return cleverapps.styles.FONTS.WINDOW_TITLE_TEXT;
            },
            cardMarkSpine: function (options) {
                return options.json;
            },
            fog: function () {
                return {};
            },
            outOfBoundaryScale: function () {
                return 0.2;
            },
            whirlwind: function () {
                return bundles.fog_animations.jsons.whirlwind;
            },
            getPoiAnimation: function () {
                return undefined;
            },
            expFlyFinishEffect: function () {
                return "menubar.exp.fly_finish";
            },
            flyToRewardBoxEffect: function () {
                return "menubar.reward.fly_to_box";
            },
            jumpCollectEffect: function () {
                return "ui.jump.collect";
            },
            hasGrabInfoView: function () {
                return false;
            }
        }
    }
};